import { computed, ref } from 'vue';

/**
 * PrimeVue's Dialog closes on Escape even when the Escape was meant for an
 * open dropdown inside it (MultiSelect / Select overlays), so one key press
 * dismissed the whole dialog and threw away the user's selections.
 *
 * Bind `closeOnEscape` to the Dialog and `onOverlayShow` / `onOverlayHide` to
 * each overlay's @show / @hide: while any overlay is open, Escape only closes
 * that overlay; with none open it closes the dialog as before.
 */
export function useOverlayAwareEscape() {
  const openOverlays = ref(0);

  const closeOnEscape = computed(() => openOverlays.value === 0);

  function onOverlayShow() {
    openOverlays.value += 1;
  }

  function onOverlayHide() {
    // The Dialog reads closeOnEscape on the same keydown that hides the
    // overlay; defer the decrement so that keydown still sees the overlay open.
    setTimeout(() => {
      openOverlays.value = Math.max(0, openOverlays.value - 1);
    }, 0);
  }

  return { closeOnEscape, onOverlayShow, onOverlayHide };
}
